import {OrganisationUserRoles} from "@qid/core";

export class AddUserDto {
  email: string = '';
  role: OrganisationUserRoles;
  orgId: any;
  name: string;

  constructor() {
  }
}
